export interface ChatCustomization {
    title: string;
    brandColor: string | null;
    /** One or more display names; the widget picks one at random per session. */
    agentNames?: string[];
    /** Opening questions shown while the conversation is still empty. */
    suggestedQuestions?: string[];
    /**
     * Greeting shown at the top of the conversation. Plain text, line breaks kept; null/blank =
     * none. With more than one line, the first is shown as its headline.
     */
    welcomeMessage?: string | null;
    iconUrl: string | null;
    showMessageAvatar?: boolean;
    /**
     * Unused: the send button is an icon with its own accessible name, and the launcher is
     * widget.js's. Still sent by the API, so kept optional rather than dropped.
     */
    buttonText?: string;
    searchPlaceholder: string;
    direction: TextDirection;
    streamResponses?: boolean;

    // Optional throughout: an API older than the new look sends none of them, and each falls back
    // to the look every tenant gets by default.

    agentBubbleStyle?: AgentBubbleStyle;
    /** How `suggestedQuestions` are laid out in the empty state. */
    suggestionsLayout?: SuggestionsLayout;
    /** Show the 2–3 questions the chat engine suggests after an answer. */
    followUpSuggestions?: boolean;
    fontFamily?: FontFamily;
    fontScale?: FontScale;
    /** Show the knowledge sources an answer drew on. */
    showSources?: boolean;
    /** Copy and 👍 / 👎 under answers. */
    showFeedback?: boolean;
    showTimestamps?: boolean;
    /** One line under the composer, e.g. "AI answers can be wrong". Plain text; null/blank = none. */
    disclaimerText?: string | null;
    /**
     * "Powered by Nubo" under the composer. Decided by the API from the tenant's plan, never by the
     * tenant, so only an explicit `true` shows it — an API that predates the field shows nothing.
     */
    showPoweredBy?: boolean;
}

export enum TextDirection {
    Auto = 0,
    Ltr = 1,
    Rtl = 2
}

export type AgentBubbleStyle = 'filled' | 'outlined' | 'plain';
export type SuggestionsLayout = 'cards' | 'chips';
export type FontFamily = 'system' | 'inter' | 'heebo' | 'rubik';
export type FontScale = 'sm' | 'md' | 'lg';
